import { KlevuEvents } from "../../events/index.js";
/**
 * This modifier should be used in the case when user hits enter (or presses button) to see
 * all results from search.
 *
 * @category Modifier
 * @returns
 */
export function sendSearchEvent() {
    return {
        klevuModifierId: "sendSearchEvent",
        onResult: (res, f) => {
            var _a;
            if (!f.params) {
                return res;
            }
            const { id, term } = f.params;
            if (!id || !term) {
                return res;
            }
            const meta = (_a = res.queriesById(id)) === null || _a === void 0 ? void 0 : _a.meta;
            if (!meta) {
                return res;
            }
            KlevuEvents.search(term, meta.totalResultsFound, meta.typeOfSearch);
            return res;
        },
    };
}
